import { Store } from './store/Store';
// import { Transactions } from './transactions/Transactions';
//import { Ddna } from './ddna/Ddna';
import { getReachedLevel } from './main';
import { XPromo } from './xpromo/XPromo';

export class App {
  public readonly store: Store;
  public sdkHandler: any
  public sgSettings: any
  // public readonly transactions: Transactions;
  // public ddna: Ddna;
  public xPromo: XPromo;

  constructor() {
    // @ts-ignore
    this.sdkHandler = window.sdkHandler;
    // @ts-ignore    
    this.sgSettings = window.sgSettings;
    // thi  s.transactions = new Transactions({ store: this.store });
    this.store = new Store(this);
  }

  public getReachedLevel(): number {
    return getReachedLevel();
  }
}

//export const app: App = new App();

// @ts-ignore
//window.app = app;
